import { Component, type ReactNode } from 'react';

/**
 * A screen that fails to load says so, and offers the way out.
 *
 * Screens load on first open (App.tsx). After a deploy, the file an open tab
 * asks for may no longer exist, and a failed lazy import with no boundary
 * unmounts the whole application — a blank page, rail and all, with nothing
 * to press. Keyed by path in the shell, so moving to another screen clears it.
 */
export class ScreenBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <section>
        <h1>This screen did not load</h1>
        <p role="alert">
          The product may have been updated since this page was opened. Reloading fetches the
          current version; nothing you saved is lost.
        </p>
        <button type="button" className="action" onClick={() => window.location.reload()}>
          Reload
        </button>
      </section>
    );
  }
}
